import { HttpStatusCode } from '../../../core/apiSchema';

export type AiSectionState = 'hidden' | 'no-access' | 'loading' | 'content';

interface iAiSectionStateParams {
    isSimpleSearchMode: boolean;
    isAiSearchEnabled: boolean;
    statusCode: number | null;
    error: Error | null;
    htmlContent: string;
    isStreamLoading: boolean;
}

interface iShouldShowNoResultsParams {
    isSearchLoading: boolean;
    hasResults: boolean;
    aiSectionState: AiSectionState;
}

export function getAiSectionState({
    isSimpleSearchMode,
    isAiSearchEnabled,
    statusCode,
    error,
    htmlContent,
    isStreamLoading
}: iAiSectionStateParams): AiSectionState {
    if (isSimpleSearchMode) return 'hidden';
    if (!isAiSearchEnabled) return 'no-access';
    if (statusCode === HttpStatusCode.NUMBER_400 || statusCode === HttpStatusCode.NUMBER_404) return 'content';
    if (statusCode !== null && statusCode >= 500) return 'hidden';
    if (htmlContent) return 'content';
    if (error) return 'hidden';
    if (statusCode !== null && !isStreamLoading) return 'content';
    return 'loading';
}

export function getFirstQueryParam(value: string | (string | null)[] | null | undefined): string {
    if (Array.isArray(value)) return value.find((item): item is string => !!item) ?? '';
    return value ?? '';
}

export function shouldShowNoResults({ isSearchLoading, hasResults, aiSectionState }: iShouldShowNoResultsParams): boolean {
    return !isSearchLoading && !hasResults && aiSectionState === 'hidden';
}
